// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__X15fz","spin":"Icon_spin__f0KS5","dark":"Icon_dark__sBtxm"};